const $ = jQuery.noConflict();
/* eslint-disable */
import Global from '../shared/global';

'use strict';
const CartPage = {
	/**
	 * @description Cache dom and strings
	 * @type {object}
	 */

	/** @description Initialize */
	init: function() {
		this.updateCart();

		$(document).on('updated_wc_div', function(e) {
			console.log(e);
			CartPage.updateCart();
		});
	},

	updateCart: function() {
		const qtyInputs = document.querySelectorAll('.input-text.qty.text');
		if (qtyInputs.length < 1) {
			return false;
		}

		let timer; // Timer identifier
		const waitTime = 1000; // Wait time in milliseconds

		const handleChange = (e) => {
			clearTimeout(timer);
			const ele = e.currentTarget;
			const updateBtn = document.querySelector('.js-update-cart-button');

			// Wait for X ms and then process the request
			timer = setTimeout(() => {
				updateBtn.click();
			}, waitTime);
		};

		for (let i = 0; i < qtyInputs.length; i++) {
			qtyInputs[i].addEventListener('input', handleChange);
			qtyInputs[i].addEventListener('change', handleChange);
		}
	}
};

export default CartPage;
